import React, { useEffect } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const MapComponent = () => {
  useEffect(() => {
    // Initialize the map
    const map = L.map('map').setView([20.5937, 78.9629], 4);

 // Add the Bhuvan WMS layer
    L.tileLayer.wms('https://bhuvan-ras1.nrsc.gov.in/tilecache/tilecache.py', {
      layers: 'bhuvan_wbase_ind',
      format: 'image/png',
      transparent: true,
      attribution: 'Bhuvan NRSC',
      maxZoom: 18,
      // Additional WMS parameters if needed
      version: '1.1.1',
      srs: 'EPSG:3857',
      Maxresolution:  156543.033928,
      styles: ''
    }).addTo(map);

    // Cleanup function to remove the map when component unmounts
    return () => {
      map.remove();
    };
  }, []);

  return <div id="map" style={{ height: '100vh', width: '100%' }} />;
};

export default MapComponent;